import { Component, Input, ElementRef, ViewChild, OnChanges } from '@angular/core';
import { LatLngBounds } from '@agm/core';
declare const google: any;

@Component({
  selector: 'formato-pdf-carpeta-ejecutiva-nota-informativa',
  templateUrl: './formato-pdf-carpeta-ejecutiva-nota-informativa.component.html',
  styleUrls: ['./formato-pdf-carpeta-ejecutiva-nota-informativa.component.scss']
})
export class FormatoPdfCarpetaEjecutivaNotaInformativaComponent implements OnChanges {

  @ViewChild('formatoHtmlPDF')
  public formatoHtmlPDF: ElementRef;

  // @Input('fichaTecnica')
  // public fichaTecnica: FichaTecnica;

  public primerEjercicioFiscal: any;
  public existePrimero: boolean = false;
  public segundoEjercicioFiscal: any;
  public existeSegundo: boolean = false;
  public tercerEjercicioFiscal: any;
  public existeTercero: boolean = false;

  public map: any;
  public marcadorInicial: any;
  public marcadorFinal: any;

  public latActual: any;
  public lngActual: any;
  public zoomActual: any;

  public fechaActual: any;

  constructor() { }

  public ngOnChanges(): void {
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    this.obtenerMarcadorInicial();
    this.obtenerMarcadorFinal();
    // let fechaConvert: Date = new Date(this.fichaTecnica.fechaActualizacion);
    // this.fechaActual = (fechaConvert.getUTCDate() + " de " + monthNames[fechaConvert.getUTCMonth()] + " de " + fechaConvert.getUTCFullYear());
    // let contadorEjercicios: number = this.fichaTecnica.ejerciciosFiscales.length;
    // if (contadorEjercicios > 0) {
      // this.primerEjercicioFiscal = this.fichaTecnica.ejerciciosFiscales[0];
      this.existePrimero = true;
    // }
    // if (contadorEjercicios > 1) {
      // this.segundoEjercicioFiscal = this.fichaTecnica.ejerciciosFiscales[1];
      this.existeSegundo = true;
    // }
    // if (contadorEjercicios > 2) {
      // this.tercerEjercicioFiscal = this.fichaTecnica.ejerciciosFiscales[2];
      this.existeTercero = true;
    // }
  }

  public obtenerMarcadorInicial(): void {
    this.marcadorInicial = {
      // lat: this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints[this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints.length - 1].lat,
      // lng: this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints[this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints.length - 1].lng
    };
  }

  public obtenerMarcadorFinal(): void {
    this.marcadorFinal = {
      // lat: this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints[0].lat,
      // lng: this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints[0].lng
    };
  }

  public mapReady(event: any): void {
    this.map = event;
    // if (!(this.fichaTecnica.googleMap.lat && this.fichaTecnica.googleMap.lng && this.fichaTecnica.googleMap.zoom)) {
      this.centrarPolyline();
    // }
  }

  //Centra en polyline en el mapa
  public centrarPolyline(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    // for (const point of this.fichaTecnica.googleMap.googlePolyline.googlePolylinePoints) {
      // bounds.extend(new google.maps.LatLng(point.lat, point.lng));
    // }
    this.map.fitBounds(bounds);
  }

  public cambioZoom(event: any): void {
    this.zoomActual = event;
  }

  public cambioCentro(event: any): void {
    this.latActual = event.lat;
    this.lngActual = event.lng;
  }

}
